/* global Swiper jQuery bodymovin Vimeo */

/*
 * Swiper for customer quotes in hero
 */
(function () {
	"use strict";

	new Swiper('.heroBox .swiper-container', {
		// Optional parameters
		loop: true,

		// If we need pagination
		pagination: {
			el: '.heroBox .swiper-pagination',
			clickable: true
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
	});

}());

// Resources slider

(function () {

	"use strict";

	// init news and events carousel
	new Swiper(".resources .resources-slider-container", {
		slidesPerView: "auto",
		navigation: false,
		pagination: {
			el: '.resources .swiper-pagination',
			type: 'bullets',
		},
		centeredSlides: false,
		spaceBetween: 30
	});

}());

/*
 * Play video if specific url hash exists
 */
(function() {
	"use strict";

	/*
	 * handle hash change
	 */
	function handleHashChange () {

		var hash;

		// get hash value
		if (window.location.hash) {

			hash = window.location.hash.substring(1);
			if (hash === "vmdr-video") {
				var poster = document.querySelector(".poster");
				var playIcon = document.querySelector(".play-icon");
				var playOverlay = document.querySelector(".q-video-poster-overlay");
				var iframe = document.querySelector("iframe");
				var player = new Vimeo.Player(iframe);
				poster.classList.add("hidden");
				playIcon.classList.add("hidden");
				playOverlay.classList.add("hidden");
				player.play();
			}

		}
	}

	window.addEventListener("hashchange", handleHashChange);
	document.addEventListener("DOMContentLoaded", handleHashChange);
} ());



(function ($) {

	"use strict";

	// expand / collapse table

	$(".expand-all").on("click", function (element) {
		var $buttonSpan = $(element.currentTarget).find("span");
		var buttonClass = $buttonSpan.attr("class");
		var header = $(".vmdr-workflow-table2 .header");
		var section = header.next(".section");

		if (buttonClass === "expand") {
			$buttonSpan.attr("class", "");
			$(element.currentTarget).find("span").text("Expand All");
			header.removeClass("expanded2");
			section.slideUp("fast");
		} else {
			$buttonSpan.attr("class", "expand");
			$(element.currentTarget).find("span").text("Collapse All");
			header.addClass("expanded2");
			section.slideDown("fast");
		}
	});

	$(".vmdr-workflow-table2 .header").each( function(){
		var $header =  $(this);
		var $section =  $header.next(".section");
		$header.on("click", function() {
			$header.toggleClass("expanded2");
			$section.slideToggle();
		});
	});

	// video overlay hide on play

	$(".play-icon, .video-link").on("click", function(){
		$(".video-overlay").addClass("hidden");
	});

	// video playlist

	$(".video-link").on("click", function(){
		var ths = $(this);
		var videoText = ths.text();
		$(".active-video").text( videoText ).removeClass("menu-active");
		$(".video-links-list").fadeOut( "fast" );
	});

	$(".active-video").on("click", function(){
		$(".video-links-list").fadeToggle( "fast" );
		$(this).toggleClass("menu-active");
	});

	$(document).mouseup(function(e) {
		var container = $(".video-playlist");

		if (!container.is(e.target) && container.has(e.target).length === 0){
			$(".video-links-list").hide();
			$(".active-video").removeClass("menu-active");
		}
	});

}(jQuery));

// hero animation

(function () {

	"use strict";

	//var animationData = {"v":"5.6.3","fr":29.9700012207031,"ip":0,"op":150.000006109625,"w":1290,"h":510,"nm":"Comp 1","ddd":0,"assets":[{"id":"image_0","w":113,"h":138,"u":"../../asset/image/apps/vmdr/banner-animation/","p":"img_0.png","e":0},{"id":"image_1","w":116,"h":133,"u":"../../asset/image/apps/vmdr/banner-animation/","p":"img_1.png","e":0},{"id":"image_2","w":130,"h":133,"u":"../../asset/image/apps/vmdr/banner-animation/","p":"img_2.png","e":0},{"id":"image_3","w":130,"h":133,"u":"../../asset/image/apps/vmdr/banner-animation/","p":"img_3.png","e":0},{"id":"image_4","w":632,"h":243,"u":"../../asset/image/apps/vmdr/banner-animation/","p":"img_4.png","e":0},{"id":"image_5","w":75,"h":75,"u":"../../asset/image/apps/vmdr/banner-animation/","p":"img_5.png","e":0}],"layers":[{"ddd":0,"ind":2,"ty":2,"nm":"R.png","cl":"png","refId":"image_0","sr":1,"ks":{"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":21,"s":[559.5,169.5,0],"to":[0,3.75,0],"ti":[0,-3.75,0]},{"t":41.0000016699642,"s":[559.5,192,0]}]},"a":{"a":0,"k":[56.5,69,0]}},"ao":0,"ip":21.0000008553475,"op":150.000006109625,"st":1.00000004073083,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"D.png","cl":"png","refId":"image_1","sr":1,"ks":{"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":14,"s":[437,172,0],"to":[0,3.75,0],"ti":[0,-3.75,0]},{"t":34.0000013848484,"s":[437,194.5,0]}]},"a":{"a":0,"k":[58,66.5,0]}},"ao":0,"ip":14.0000005702317,"op":150.000006109625,"st":-6.00000024438501,"bm":0},{"ddd":0,"ind":4,"ty":2,"nm":"M.png","cl":"png","refId":"image_2","sr":1,"ks":{"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":6,"s":[302,172,0],"to":[0,3.75,0],"ti":[0,-3.75,0]},{"t":26.0000010590017,"s":[302,194.5,0]}]},"a":{"a":0,"k":[65,66.5,0]}},"ao":0,"ip":6.00000024438501,"op":150.000006109625,"st":-14.0000005702317,"bm":0},{"ddd":0,"ind":5,"ty":2,"nm":"V.png","cl":"png","refId":"image_3","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":2.00000008146167,"s":[100]}]},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[167.125,172,0],"to":[0,3.75,0],"ti":[0,-3.75,0]},{"t":20.0000008146167,"s":[167.125,194.5,0]}]},"a":{"a":0,"k":[65,66.5,0]}},"ao":0,"ip":0,"op":150.000006109625,"st":-20.0000008146167,"bm":0},{"ddd":0,"ind":6,"ty":2,"nm":"shadow.png","cl":"png","refId":"image_4","sr":1,"ks":{"p":{"a":0,"k":[466,263,0]},"a":{"a":0,"k":[316,121.5,0]}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"a","pt":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":41,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[212,-236.5],[-92,182.5],[-83,192.5],[227,-227.5]],"c":true}]},{"t":74.0000030140818,"s":[{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[212,-236.5],[-92,182.5],[249,564.5],[791,315.5]],"c":true}]}]},"o":{"a":0,"k":100},"x":{"a":0,"k":0},"nm":"Mask 1"}],"ip":41.0000016699642,"op":150.000006109625,"st":-7.00000028511585,"bm":0},{"ddd":0,"ind":7,"ty":2,"nm":"dot.png","cl":"png","refId":"image_5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":55,"s":[0]},{"t":70.0000028511585,"s":[100]}]},"p":{"a":0,"k":[1223.625,316.75,0]},"a":{"a":0,"k":[37.5,37.5,0]}},"ao":0,"ip":55.0000022401959,"op":150.000006109625,"st":-20.0000008146167,"bm":0},{"ddd":0,"ind":8,"ty":2,"nm":"dot.png","cl":"png","refId":"image_5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":63,"s":[0]},{"t":78.0000031770051,"s":[100]}]},"p":{"a":0,"k":[570.375,366.5,0]},"a":{"a":0,"k":[37.5,37.5,0]}},"ao":0,"ip":63.0000025660426,"op":150.000006109625,"st":-12.00000048877,"bm":0},{"ddd":0,"ind":9,"ty":2,"nm":"dot.png","cl":"png","refId":"image_5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":70,"s":[0]},{"t":85.000003462121,"s":[100]}]},"p":{"a":0,"k":[468.125,416.75,0]},"a":{"a":0,"k":[37.5,37.5,0]}},"ao":0,"ip":70.0000028511585,"op":150.000006109625,"st":-5.00000020365417,"bm":0},{"ddd":0,"ind":10,"ty":2,"nm":"dot.png","cl":"png","refId":"image_5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":78,"s":[0]},{"t":93.0000037879676,"s":[100]}]},"p":{"a":0,"k":[341.875,91,0]},"a":{"a":0,"k":[37.5,37.5,0]}},"ao":0,"ip":78.0000031770051,"op":150.000006109625,"st":3.00000012219251,"bm":0},{"ddd":0,"ind":11,"ty":2,"nm":"dot.png","cl":"png","refId":"image_5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":85,"s":[0]},{"t":100.000004073084,"s":[100]}]},"p":{"a":0,"k":[91.125,40.75,0]},"a":{"a":0,"k":[37.5,37.5,0]}},"ao":0,"ip":85.000003462121,"op":150.000006109625,"st":10.0000004073083,"bm":0}],"markers":[]};

	// var animation = bodymovin.loadAnimation({
	// 	container: document.getElementById('animation'),
	// 	renderer: 'svg',
	// 	loop: false,
	// 	autoplay: false,
	// 	animationData: animationData
	// });

	// start animation AFTER hero image completes animating
	// var heroImage = document.querySelector(".q-default-hero__image") || null;

	// heroImage.addEventListener("heroImageComplete", function () {
	// 	animation.play();
	// });

}());

// screenshot animation

(function () {

	"use strict";

	var animationData = {"v":"5.6.3","fr":29.9700012207031,"ip":0,"op":290.000011811942,"w":2164,"h":1520,"nm":"Comp 1","ddd":0,"assets":[{"id":"image_0","w":151,"h":177,"u":"../../asset/image/apps/vmdr/screenshot-animation/","p":"img_0.png","e":0},{"id":"image_1","w":2164,"h":1520,"u":"../../asset/image/apps/vmdr/screenshot-animation/","p":"img_1.jpg","e":0},{"id":"image_2","w":2164,"h":1520,"u":"../../asset/image/apps/vmdr/screenshot-animation/","p":"img_2.jpg","e":0},{"id":"image_3","w":2164,"h":1520,"u":"../../asset/image/apps/vmdr/screenshot-animation/","p":"img_3.jpg","e":0}],"layers":[{"ddd":0,"ind":1,"ty":2,"nm":"hand.png","cl":"png","refId":"image_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":75,"s":[903,1035,0],"to":[36.667,0,0],"ti":[-36.667,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":90,"s":[1123,1035,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":165,"s":[1123,1035,0],"to":[29.667,0,0],"ti":[-29.667,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":180,"s":[1301,1035,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":255,"s":[1301,1035,0],"to":[-66.333,0,0],"ti":[66.333,0,0]},{"t":277.000011282441,"s":[903,1035,0]}],"ix":2},"a":{"a":0,"k":[75.5,88.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":90,"s":[40,40,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":92,"s":[35,35,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":94,"s":[40,40,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":180,"s":[40,40,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":182,"s":[35,35,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":184,"s":[40,40,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":277,"s":[40,40,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"t":279,"s":[35,35,100]},{"t":281.000011445365,"s":[40,40,100]}],"ix":6}},"ao":0,"ip":0,"op":290.000011811942,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":2,"nm":"03.png","cl":"png","refId":"image_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1082,760,0],"ix":2},"a":{"a":0,"k":[1082,760,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":182.000007413012,"op":279.000011363903,"st":-41.0000016699642,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"02.png","cl":"png","refId":"image_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1082,760,0],"ix":2},"a":{"a":0,"k":[1082,760,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":92.0000037472368,"op":279.000011363903,"st":-26.0000010590017,"bm":0},{"ddd":0,"ind":4,"ty":2,"nm":"01.png","cl":"png","refId":"image_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1082,760,0],"ix":2},"a":{"a":0,"k":[1082,760,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":290.000011811942,"st":0,"bm":0}],"markers":[]};

	var animationBelow = bodymovin.loadAnimation({
		container: document.getElementById('animation2'),
		renderer: 'svg',
		loop: true,
		autoplay: false,
		animationData: animationData
	});

	animationBelow.play();

	var animationAbove = bodymovin.loadAnimation({
		container: document.getElementById('animation3'),
		renderer: 'svg',
		loop: true,
		autoplay: false,
		animationData: animationData
	});

	animationAbove.play();

}());
